import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from './toast.service';
import { ToastComponent } from './toast.component';
import { MessageBoxComponent } from './message-box/message-box.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatSnackBarModule,
    MatButtonModule,
    TranslateModule,
    ToastComponent,
    MessageBoxComponent,
  ],
  providers: [ToastService],
  exports: [MessageBoxComponent],
})
export class ToastModule {}
